function toggleFilterGroup(event) {
  const filterGroupLabel = event.target;
  const filterGroupId = filterGroupLabel.getAttribute("data-filter-id");
  if (!filterGroupId) {
    return;
  }
  const filterGroupDropdown = document.querySelector(
    `.collection-filters__filter-group-dropdown[data-filter-id='${filterGroupId}']`
  );
  if (!filterGroupDropdown) {
    return;
  }
  const filterGroupDropdownVisible =
    filterGroupDropdown.classList.contains("visible");
  if (filterGroupDropdownVisible) {
    filterGroupLabel.classList.remove("visible");
    filterGroupDropdown.classList.remove("visible");
    if (filterGroupLabel) {
      filterGroupLabel.focus();
    }
  } else {
    filterGroupLabel.classList.add("visible");
    filterGroupDropdown.classList.add("visible");
  }
}
function showMobileFilters() {
  const filtersElement = document.getElementById("collection-filters");
  if (!filtersElement) {
    return;
  }
  filtersElement.classList.add("visible-mobile");
  document.body.classList.add("locked");
}
function hideMobileFilters(e) {
  e.preventDefault();
  const filtersElement = document.getElementById("collection-filters");
  if (!filtersElement) {
    return;
  }
  filtersElement.classList.remove("visible-mobile");
  document.body.classList.remove("locked");
}
const sortByForms = document.querySelectorAll("[data-sort-by]");
sortByForms.forEach((sortByForm) => {
  sortByForm.addEventListener("change", function (event) {
    const element = event.target;
    const value = element.value.toString();
    const activeFilters = element.getAttribute("data-active-filters");
    if (activeFilters) {
      location.search = activeFilters + "&sort_by=" + value;
    } else {
      location.search = "sort_by=" + value;
    }
  });
});

class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.timer;
  }
  connectedCallback() {
    const self = this;
    self._addEventListeners();
  }
  _addEventListeners() {
    const self = this;
    self.inputs = self.querySelectorAll('input:not([type="number"])');
    self.ranges = self.querySelectorAll('input[type="number"]');
    self.inputs.forEach((input) => {
      input.addEventListener("change", self._changeActiveFilters.bind(self));
    });
    self.ranges.forEach((range) => {
      range.addEventListener("keyup", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        clearTimeout(self.timer); //clear any running timeout on key up
        self.timer = setTimeout(function () {
          self._updateRange(e).bind(self);
        }, 500);
      });
    });
  }
  _changeActiveFilters(e) {
    const self = this;
    document.getElementById("ProductGridContainer").classList.add('loading');
    const currentParams = new URLSearchParams(location.search);
    const input = e.target;
    if (input.checked) {
      currentParams.append(input.name, input.value);
    } else {
      currentParams.delete(input.name, input.value);
    }
    if (currentParams.has("page")) {
      currentParams.delete("page");
    }
    self._requestNewHTML(currentParams);
  }
  _getOpenAccordions() {
    const self = this;
    const ids = [];
    self.querySelectorAll(".collection-filters__filter-group-label.visible").forEach(function (elem) {
      ids.push(elem.dataset.filterId);
    });
    return ids;
  }
  _updateRange(e) {
    const self = this;
    document.getElementById("ProductGridContainer").classList.add("loading");
    const currentParams = new URLSearchParams(location.search);
    const input = e.target;
    const otherRange = document.querySelector(`input[type="number"]:not(${input.id})`);
    if (currentParams.has(input.name) && input.value != "") {
      currentParams.set(input.name, input.value);
      currentParams.set(otherRange.name, otherRange.value);
    } else if(input.value == "") {
      currentParams.delete(input.name);
      currentParams.delete(otherRange.name);
    } else {
      currentParams.append(input.name, input.value);
      currentParams.append(otherRange.name, otherRange.value);
    }
    if (currentParams.has('page')) {
      currentParams.delete('page');
    }
    self._requestNewHTML(currentParams);
  }
  async _requestNewHTML(currentParams) {
    const self = this;
    const newURL = `${location.origin}${location.pathname}?${currentParams.toString()}`;
    const res = await fetch(newURL);
    const htmlText = await res.text();
    const parser = new DOMParser();
    const newHTML = parser.parseFromString(htmlText, 'text/html');
    self._updateHTML(newHTML, newURL);
  }
  _updateHTML(newHTML, newURL) {
    const self = this,
      openAccordions = self._getOpenAccordions(),
      productGrid = document.querySelector("#product-grid"),
      newGrid = newHTML.querySelector("#product-grid"),
      paginationWrapper = document.querySelector(".pagination-wrapper"),
      newPaginationWrapper = newHTML.querySelector(".pagination-wrapper");
    openAccordions.forEach(function (accordion) {
      newHTML.querySelector(`.collection-filters__filter-group-label[data-filter-id="${accordion}"]`).classList.add('visible');
      newHTML.querySelector(`.collection-filters__filter-group-dropdown[data-filter-id="${accordion}"]`).classList.add('visible');
    });
    productGrid.innerHTML = newGrid.innerHTML;
    self.querySelector("#collection-filters-form").innerHTML = newHTML.querySelector("#collection-filters-form").innerHTML;
    if (newPaginationWrapper && paginationWrapper) {
      paginationWrapper.innerHTML = newPaginationWrapper.innerHTML;
    } else if (newPaginationWrapper) {
      productGrid.after(newPaginationWrapper);
    } else if (paginationWrapper) {
      paginationWrapper.innerHTML = "";
    }
    self._addEventListeners();
    document.getElementById("ProductGridContainer").classList.remove("loading");
    window.history.pushState({}, null, newURL);
  }
}

customElements.define('collection-filters', CollectionFilters);